import { render, staticRenderFns } from "./sidebarLayers.vue?vue&type=template&id=2ffb6439&"
import script from "./sidebarLayers.vue?vue&type=script&lang=js&"
export * from "./sidebarLayers.vue?vue&type=script&lang=js&"
import style0 from "./sidebarLayers.vue?vue&type=style&index=0&id=2ffb6439&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports